import { useState, useRef, useEffect } from "react";
import Loader from "../Loader";
import { Link, useNavigate } from "react-router-dom";

const ForgotPassword = () => {

  const navigate = useNavigate();

  useEffect(() => {
    if(localStorage.getItem('linkedin-scheduler-token')) {
      navigate('/panel/dashboard')
    }
  }, [])

  const emailRef = useRef();

  const defaultValidationState = {
    email: { invalid: false, message: 'Please enter email' },
  };

  const [validateValues, setValidateValues] = useState(defaultValidationState)
  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const isEmpty = (value) => !value || value.trim().length === 0;

  const submitHandler = async (event) => {
    setValidateValues(defaultValidationState);
    setResponse(null);
    event.preventDefault();

    const email = emailRef.current.value;

    let isValid = true;

    if(isEmpty(email)) {
      setValidateValues((prevState) => {
        return {...prevState, email: {...prevState.email, invalid: true}}
      });
      isValid = false;
    }

    const formData = {};
    // const formData = new Object();

    
    if(isValid) {
      setIsLoading(true);
      formData.email = email;
      Object.freeze(formData);

      console.table(formData);

      try {
        const response = await fetch(process.env.REACT_APP_EXPRESS_URL + '/auth/forgot/password', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
  
        if(!response.ok) {
  
          const error = await response.json();
  
          if(response.status === 422) {
  
            console.table(error.errors);
            for (const key of error.errors) {
  
              setValidateValues((prevState) => {
                return {...prevState, [key.path]: {message: [key.msg], invalid: true}}
              });
            }
            
          } else {
            setResponse((prevState) => {
              return {success :false, message: error.message};
            }) 
          }
           
          setTimeout(() => {
            setResponse(null);
          }, 3000);
          
          return;    
        }
        const data = await response.json();
  
        setResponse((prevState) => {
          return {success :true, message: data.message};
        })
  
        setTimeout(() => {
          setResponse(null);
          navigate('/login');
        }, 3000);
      } catch (error) {
        
        setResponse((prevState) => ({
          success: false,
          message: 'Something went wrong. Please try again.',
        }));
      } finally {
        setIsLoading(false); // Disable loader after receiving response (regardless of success or error)
      }

      
    }
  };

  const closeAlert = () => setResponse(null);

    return (
      <div className="flex h-screen bg-gray-900">
      {/* Left side with background image */}
      <div
        className="hidden md:flex w-1/2 h-full bg-cover bg-center"
        style={{
          backgroundImage:
           "url('/assets/login-bg-image-png.png')",
        }}
      >
        <div className="bg-opacity-50 w-full h-full flex items-center justify-center">
          <h1 className="text-white text-4xl font-bold max-w-md text-center">
            Schedule & Manage Your LinkedIn Posts Effortlessly 🚀
          </h1>
        </div>
      </div>

      {/* Right side with login form */}
      <div className="flex w-full md:w-1/2 items-center justify-center bg-gray-800 p-10">
        <div className="w-full max-w-md space-y-6">
          <div className="flex items-center justify-center gap-2 mb-4">
            <h1 className="text-3xl font-bold text-blue flex items-center gap-2">
              <i class="text-3xl fa fa-paper-plane"></i>
              PostPro
            </h1>
          </div>
          <div className="text-center">
            <h2 className="text-3xl font-semibold text-white">Reset your password</h2>
            <p className="text-gray-400">To reset your password, enter your email below and submit.
              An email will be sent to you with the link to reset your password.
            </p>
          </div>

          {response && response.success && (
            <div className="bg-green-500 text-white px-4 py-2 rounded relative">
              <span>{response.message}</span>
              <button
                className="absolute right-2 top-2 text-white"
                onClick={closeAlert}
              >
                ×
              </button>
            </div>
          )}

          {response && !response.success && 
            (<div className="relative bg-rose-100 text-rose-600 px-4 py-3 rounded-lg text-sm border border-rose-300 transition-opacity duration-500 ease-in-out">
              <span>{response.message}</span>
              <button
                className="absolute right-2 top-2 text-rose-500 hover:text-rose-700"
                aria-label="Close"
                onClick={closeAlert}
              >
                &times;
              </button>
            </div>)
          }
          <div className="w-full max-w-md space-y-6 relative">
            {isLoading && <Loader />}
            <form className="space-y-4" onSubmit={submitHandler}>
              <div>
                <label className="block mb-1 text-sm text-gray-300">Email</label>
                <input
                  type="email"
                  className={`w-full px-4 py-2 border border-gray-600 rounded-lg bg-gray-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 ${validateValues.email.invalid ? 'is-invalid' : ''}`}
                  autoFocus={true}
                  // className={`form-control ${validateValues.email.invalid ? 'is-invalid' : ''}`}
                  id="email"
                  placeholder="Enter email"
                  ref={emailRef}
                  aria-describedby="email-error"
                  aria-invalid="true"
                />
                {validateValues.email.invalid && (
                  <span id="email-error" className="text-rose-400 text-sm mt-1 block">
                    {validateValues.email.message}
                  </span>
                )}
              </div>

              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
                // submitHandler={submitHandler}
              >
                Reset Password
              </button>

              <div className="flex justify-between text-sm text-blue-400 mt-2">
                <Link to="/login">Remember Your Password</Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    );
  };
  
  export default ForgotPassword;
  